import Vuex from 'vuex'
import theme from '@/store/theme.js'
import auth from '@/store/auth.js'
import home from '@/store/home.js'
import dailyAttendance from '@/store/attendance/daily_attendance.js'
import subjectAttendance from '@/store/attendance/subject_attendance'
import recruitment from '@/store/recruitment/recruitment'
import studyroom from '@/store/academic/studyroom'
import calendar from './academic/calendar'
import payment from '@/store/finance/payment'
import saving from '@/store/finance/saving'
import paymentSummary from '@/store/finance/summary'
import exam from '@/store/academic/exam'
import profile from '@/store/profile'
import network from '@/store/network'
import journal from '@/store/journal'
import sos from '@/store/complaint/sos'
import laporin from '@/store/complaint/laporin'
import erapor from '@/store/erapor'
import guestBook from '@/store/guestBook/guestBook'
import evaluation from '@/store/academic/evaluation'
import news from '@/store/news'
import tilawah from '@/store/religions/tilawah'
import tahfidz from './religions/tahfidz'
import eraporKeagamaan from '@/store/religions/eraporKeagamaan'
import studentBill from './schoolAdmin/studentBill'
import teacherDaily from '@/store/teacherAttendance/daily'
import teacherSubject from '@/store/teacherAttendance/subject'
import teacherMonitor from '@/store/teacherAttendance/monitor'
import teacherJournal from '@/store/teacherJournal/teacherJournal'

export default new Vuex.Store({
  modules: {
    theme,
    auth,
    home,
    dailyAttendance,
    subjectAttendance,
    recruitment,
    studyroom,
    calendar,
    payment,
    saving,
    paymentSummary,
    exam,
    profile,
    network,
    journal,
    sos,
    erapor,
    guestBook,
    evaluation,
    news,
    tilawah,
    tahfidz,
    eraporKeagamaan,
    laporin,
    studentBill,
    teacherDaily,
    teacherSubject,
    teacherMonitor,
    teacherJournal
  },
  state: {
    isLoading: false,
    baseURL: null,
    showSwitchAccount: false,
    showPopUpModal: false,
    popUpModalTitle: null,
    popUpModalDescription: null,
    popUpModalIsSuccess: null,
    showConfirmationModal1: false,
    showConfirmationModal2: false,
  },
  getters: {
  },
  mutations: {
    async SET_DOMAIN(state) {
      const preferences = await JSON.parse(localStorage.getItem('preferences'))
      const domain = await preferences?.schools?.find(user => user.isActive)?.domain || ''
      //console.log('Domain:', domain)
      state.baseURL = domain || null
    }
  },
  actions: {
    async setDomain({ commit }) {
      commit('SET_DOMAIN')
    }
  }
})
